import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupScoreboardComponent } from './group-scoreboard.component';
import { ScoreboardColumnModule } from '../scoreboard-column/scoreboard-column.module';
import { SimpleSelectModule } from '../simple-select/simple-select.module';
import { SvgIconModule } from '../svg-icon';



@NgModule({
    declarations: [
        GroupScoreboardComponent
    ],
    imports: [
        CommonModule,
        ScoreboardColumnModule,
        SimpleSelectModule,
        SvgIconModule
    ],
    exports: [
        GroupScoreboardComponent
    ]
})
export class GroupScoreboardModule { }
